import {Injectable} from "@angular/core";
import {map} from "rxjs/operators";
import {DataService} from "../shared/data.service";
import {ApiEndpoints} from "../shared/ApiEndpoints";

@Injectable()
export class LogsService extends DataService{

  getItems() {
    return this.getRequest(ApiEndpoints.logs);
  }


  getDeviceLogs(deviceID) {
    return this.getRequest(`${ApiEndpoints.devicelogs}/${deviceID}`)
  }
}
